(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mot-responsive-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mot-responsive-video')) {
    customElements.define('mot-responsive-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.playing = () => this.setAttribute('data-playing', '');
        this.failed = () => this.removeAttribute('data-playing');
        this.refresh = () => this.updatePlayback();
        this.video.addEventListener('playing', this.playing);
        this.video.addEventListener('error', this.failed);
        document.addEventListener('visibilitychange', this.refresh);
        this.motion.addEventListener('change', this.refresh);
        if ('IntersectionObserver' in window) {
          this.loadObserver = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting) && !this.motion.matches && !document.hidden) {
              this.loadSource();
            }
          }, { rootMargin: '200px 0px' });
          this.playObserver = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.updatePlayback();
          }, { threshold: 0.01 });
          this.loadObserver.observe(this);
          this.playObserver.observe(this);
        } else {
          this.visible = true;
          this.updatePlayback();
        }
      }

      loadSource() {
        if (this.video.getAttribute('src')) return;
        const rect = this.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const density = Math.min(window.devicePixelRatio || 1, 2);
        const sources = Array.from(this.video.querySelectorAll('source[data-src]'))
          .filter(source => this.video.canPlayType(source.type))
          .sort((a, b) => Number(a.dataset.width) - Number(b.dataset.width));
        const source = sources.find(item => Number(item.dataset.width) >= rect.width * density && Number(item.dataset.height) >= rect.height * density) || sources[sources.length - 1];
        if (!source) return;
        this.video.muted = true;
        this.video.src = source.dataset.src;
        this.video.preload = 'auto';
        this.video.load();
        this.loadObserver?.disconnect();
      }

      updatePlayback() {
        if (!this.visible || document.hidden || this.motion.matches) {
          this.video.pause();
          if (this.motion.matches) this.removeAttribute('data-playing');
          return;
        }
        this.loadSource();
        if (this.video.getAttribute('src')) {
          const play = this.video.play();
          if (play) play.catch(() => {});
        }
      }

      disconnectedCallback() {
        this.loadObserver?.disconnect();
        this.playObserver?.disconnect();
        this.video?.pause();
        this.video?.removeEventListener('playing', this.playing);
        this.video?.removeEventListener('error', this.failed);
        document.removeEventListener('visibilitychange', this.refresh);
        this.motion?.removeEventListener('change', this.refresh);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
